import React from 'react';
import { Link } from 'react-router-dom';
import strings from 'helper/localization/localization';

const AgeExit = () => (
  <div className="container">
    <div className="row">
      <div className="col">
        <Link to="/login" className="btn btn-outline-primary">
          {strings.cancel}
        </Link>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <h6>{strings.signUpWithMimi}</h6>
        <h2>{strings.youngerThan16}</h2>
        <p>{strings.youngerLegal}</p>
      </div>
    </div>
    <Link to="/login" className="btn btn-outline-primary btn-lg btn-block">
      {strings.cancelSignup}
    </Link>
  </div>
);

export default AgeExit;



// WEBPACK FOOTER //
// ./src/modules/signup/AgeExit.jsx